import { createSelector } from 'reselect';

import type { MayBe } from 'modules/global/typing/common/common';
import type { TireScansReducer } from 'modules/tireScan/reducers';
import type { NextPageParameters, TireScan } from 'modules/tireScan/types';

type State = { tireScan: TireScansReducer };

const getState = (state: State) => state.tireScan;

const getEntities = createSelector(getState, state => state.data.entities);

const getUI = createSelector(getState, state => state.ui);

const getUIImport = createSelector(getUI, UI => UI.import);

const getModalState = createSelector(getUIImport, UI => UI.modal);

const getUIImportModalIds = createSelector(getModalState, state => state.ids);

export const getUIImportEntities = createSelector(getEntities, getUIImportModalIds, (entities, ids) =>
  ids.map(id => entities[id]));

export const hasError = createSelector(getModalState, state => Boolean(state.error));

export const isFetching = createSelector(getModalState, state => state.loading);

export const hasNext = createSelector(getModalState, state => state.hasMore);

const getLastModalEntity = createSelector(getEntities, getUIImportModalIds, (entities, ids): MayBe<TireScan> => {
  const lastId = ids.at(-1);
  return lastId ? entities[lastId] : undefined;
});

export const getNextPageParams = createSelector(hasNext, getLastModalEntity, (hasMore, tireScan): NextPageParameters => {
  if (hasMore) {
    return {
      lastVin: tireScan?.vin,
      lastRegistration: tireScan?.registration,
    };
  }
  return {};
});
